export interface ISearchParams {
  search: string;
  documentType: string;
  documentNumber: string;
  documentDate: any
  searchType: string; // common, ext
  docStatuse: any;
}

class SearchFilterController {
  private params: ISearchParams;
  private onFind: () => void;
  private onSearch: () => void;
  private statuses: any[];
  private groupedChapters: any[];

  search() {
    this.onSearch();
  }

  find() {
    this.onFind();
  }
}

export const SearchFilterComponent: angular.IComponentOptions = {
  controller: SearchFilterController,
  template: require('./search-filter.html'),
  bindings: {
    params: "<",
    onFind: "&",
    onSearch: "&",
    groupedChapters: "<",
    statuses: "<"
  }
};



// WEBPACK FOOTER //
// ./src/components/linkedDocuments/search-filter.ts